module.exports = __webpack_public_path__ + "img/product4.ef9d0e46.png";